const initialState = {
  isSaving: false,
  pricingCartData: { items: [] },
  loading: false,
  loaded: false,
};

export const CART_ACTION_ENUM = {
  UPDATE_CART: "update_cart",
  UPDATE_ITEM_SIZE: "update_item_sizes",
  SET_SAVING: "set_saving",
  UPDATE_LOADING: "update_cart_loading",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CART_ACTION_ENUM.UPDATE_CART:
      //return { ...state, pricingCartData: action.payload };
      return {
        ...state,
        pricingCartData: action.payload,
        loaded: true,
        loading: false,
      };
    case CART_ACTION_ENUM.UPDATE_LOADING:
      return { ...state, loading: true, loaded: false };

    case CART_ACTION_ENUM.UPDATE_ITEM_SIZE:
      const { id, size, amount } = action.payload;
      const cartItemToUpdate = state.pricingCartData.items.find(
        (s) => s.id === id
      );
      const cartItemSizeToUpdate = cartItemToUpdate.sizes.find(
        (cartItemSize) => cartItemSize.name === size.name
      );
      cartItemSizeToUpdate.qty = amount;
      const newState = { ...state };
      return newState;
    case CART_ACTION_ENUM.SET_SAVING:
      return { ...state, isSaving: action.payload };
    default:
      return state;
  }
};

export default reducer;
